import React from 'react';
import classnames from 'classnames';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

import Icon from 'components/Misc/Icon';

export const Container = SortableContainer(({ children, className }) => {
	return (
		<div className={className}>
			{children}
		</div>
	);
});

export const Element = SortableElement(({ children, className }) => {
	return (
		<div className={className}>
			{children}
		</div>
	);
});

export const Handle = SortableHandle(({ className }) => {
	const cls = classnames(
		'text-neutral-800 dark:text-white cursor-move transition-colors',
		className
	);

	return (
		<Icon
			icon="drag_indicator"
			className={cls}
		/>
	);
});